/**
 * A single flaky CMS request can otherwise fail an entire `next build` outright — there's no
 * previously-cached page to fall back to on the first build, unlike a runtime ISR revalidation
 * where a stale-but-served page absorbs the same blip.
 */
export const withRetries = async <T>(
  fn: () => Promise<T>,
  retries = 2,
  delayMs = 500
): Promise<T> => {
  for (let attempt = 0; ; attempt++) {
    try {
      return await fn();
    } catch (err) {
      if (attempt >= retries) throw err;
      await new Promise((resolve) => setTimeout(resolve, delayMs * (attempt + 1)));
    }
  }
};
